import { useMemo } from "react";

import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";
import { useAllPlans } from "routes/data-routes/billing-data/plans";
import { usePlanHelpers } from "routes/data-routes/billing-data/plans/usePlanHelpers";
import { useUser } from "routes/dataroutes/UserData";


export function useNextHigherPlan() {
  const { activeSubscription, activeSubscriptionFetcher } = useActiveSubscription();
  const user = useUser();
  const { allPlansFetcher } = useAllPlans();
  const { getUpgradeTarget } = usePlanHelpers();

  const isLoading = (activeSubscriptionFetcher.state === "loading") || (allPlansFetcher.state === "loading");

  const effectivePlanSlug = activeSubscription?.planSlug || user?.planSlug;
  const nextPlan = useMemo(() => getUpgradeTarget(effectivePlanSlug), [ effectivePlanSlug, getUpgradeTarget ]);

  return {
    nextHigherPlan: nextPlan,
    isLoading
  };
}
